var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.662,
    height: 107.64,
    viewBox: "0 0 107.662 107.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497572",
    "data-name": "Path 497572",
    d: "M107.652,15.941a44.488,44.488,0,0,1-12.67,3.342,21.557,21.557,0,0,0,9.71-11.752,45.682,45.682,0,0,1-14.016,5.175A22.455,22.455,0,0,0,74.553,6c-12.2,0-22.089,9.51-22.089,21.24a20.5,20.5,0,0,0,.583,4.83A63.639,63.639,0,0,1,7.525,9.86,20.516,20.516,0,0,0,4.542,20.534a21,21,0,0,0,9.8,17.682,22.9,22.9,0,0,1-10-2.652v.259A21.452,21.452,0,0,0,22.056,56.653a23.433,23.433,0,0,1-5.83.755,24.124,24.124,0,0,1-4.149-.388,22.012,22.012,0,0,0,20.609,14.75,45.3,45.3,0,0,1-27.426,9.1,47.343,47.343,0,0,1-5.27-.3A64.337,64.337,0,0,0,33.852,90.12c40.612,0,62.835-32.367,62.835-60.443,0-.927-.022-1.833-.045-2.739a43.875,43.875,0,0,0,11.011-10.976Z",
    transform: "translate(0 9.697)",
    fill: "#1da1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497573",
    "data-name": "Path 497573",
    d: "M0,0H107.636V107.64H0Z",
    transform: "translate(0.016)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.2d0707bed70a5ed6fee2cbe4932556b1.svg";
export { ForwardRef as ReactComponent };